import {COUNTRY_CODES} from '@/utils/constants/countryConstants'
import {NEW_THEME_FEATURE_COUNTRIES} from '@/utils/constants/marketFeatureCountries'
import {ThemeProvider as NewThemeProvider} from '@pepsico-ds/ui'
import {ThemeProvider as LegacyThemeProvider} from 'pepsico-ds'
import {useEffect} from 'react'

const DEFAULT_NEW_THEME = 'Dark PepsiConnect'
const DEFAULT_LEGACY_THEME = 'Dark Peacock'

let isNewThemeCssLoaded = false

export const MarketThemeProvider = ({market = COUNTRY_CODES.MX, children}) => {
  const useNewTheme = NEW_THEME_FEATURE_COUNTRIES.includes(market)
  useEffect(() => {
    if (useNewTheme && !isNewThemeCssLoaded) {
      import('./newThemeCss').then(() => {
        isNewThemeCssLoaded = true
      })
    }
  }, [useNewTheme])

  console.log('MarketThemeProvider: ', market)

  const ThemeProviderComponent = useNewTheme ? NewThemeProvider : LegacyThemeProvider
  const defaultTheme = useNewTheme ? DEFAULT_NEW_THEME : DEFAULT_LEGACY_THEME

  return <ThemeProviderComponent defaultStyle={defaultTheme}>{children}</ThemeProviderComponent>
}

export default MarketThemeProvider
